
import {computed, defineComponent} from 'vue';
import BlogSummary from "@/components/blog/components/BlogSummary.vue";
import {useStore} from "vuex";

export default defineComponent({
  name: 'BlogIndex',
  components: {
    BlogSummary,
  },
  setup() {
    const store = useStore()
    const posts = computed(() => store.getters.allPosts);

    return {
      posts,
      postCount: computed(() => posts.value.length),

      async deletePost(slug: string) {
        await store.dispatch('deletePost', slug )
        console.log(`Deleted ${slug} successfully`)
      }
    }
  },
});
